import { Translation } from '../types';

export const fr: Translation = {
  common: {
    loading: 'Chargement...',
    error: 'Erreur',
    cancel: 'Annuler',
    save: 'Enregistrer',
    close: 'Fermer',
    search: 'Rechercher',
    reload: 'Actualiser',
    logout: 'Déconnexion',
    dashboard: 'Tableau de bord',
    products: 'Produits',
    settings: 'Paramètres',
    language: 'Langue',
    businessHours: 'Horaires d\'ouverture',
    back: 'Retour',
    selectAll: 'Tout sélectionner',
    deselectAll: 'Tout désélectionner',
    success: 'Succès',
    selected: 'Sélectionné',
    confirm: 'Confirmer',
    required: 'Requis',
    requiredMarker: '*',
    previous: 'Précédent',
    next: 'Suivant',
    allRightsReserved: 'Tous droits réservés.',
  },
  auth: {
    login: 'Connexion',
    email: 'Adresse e-mail',
    password: 'Mot de passe',
    loginButton: 'Se connecter',
    loggingIn: 'Connexion en cours...',
    loginSuccess: 'Connexion réussie',
    loginError: 'E-mail ou mot de passe incorrect',
    invalidEmail: 'Veuillez saisir une adresse e-mail valide',
    requiredFields: 'Veuillez saisir votre e-mail et mot de passe',
    demoAccount: 'Compte de démonstration :',
    loginDescription: 'Connectez-vous à votre compte',
    welcomeMessage: 'Bienvenue dans votre espace professionnel',
    // Registration
    register: 'S\'inscrire',
    createAccount: 'Créer un compte',
    confirmPassword: 'Confirmer le mot de passe',
    passwordRequirements: 'Min. 8 caractères : majuscules, minuscules, chiffres et symboles',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
    registrationSuccess: 'Inscription réussie',
    registrationDescription: 'Créez votre compte professionnel',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    signIn: 'Se connecter',
    dontHaveAccount: 'Vous n\'avez pas de compte ?',
    creatingAccount: 'Création du compte...',
    registrationNote: 'Note :',
    registrationNotePoints: {
      erpLinking: 'Si vous avez un compte professionnel existant, votre e-mail sera automatiquement lié',
      companyEmail: 'Veuillez utiliser votre adresse e-mail professionnelle pour l\'inscription',
      contactSupport: 'Contactez le support si vous avez besoin d\'aide pour l\'inscription'
    },
    b2bUsers: 'Clients professionnels :',
    registeredEmail: 'Adresse e-mail enregistrée',
    registeredPassword: 'Mot de passe défini lors de l\'inscription',
    b2bCustomerRequired: 'E-mail non reconnu. Contactez notre service commercial pour ouvrir un compte professionnel.',
    b2bVerificationError: 'Erreur de vérification. Contactez le support.',
    // Password Reset
    passwordReset: 'Réinitialisation du mot de passe',
    passwordResetDescription: 'Recevez un mot de passe temporaire par e-mail',
    getTemporaryPassword: 'Obtenir un mot de passe temporaire',
    processing: 'Traitement en cours...',
    passwordResetComplete: 'Réinitialisation du mot de passe terminée',
    temporaryPasswordGenerated: 'Mot de passe temporaire généré',
    temporaryPassword: 'Mot de passe temporaire',
    backToLogin: 'Retour à la connexion',
    securityNotice: 'Avis de sécurité :',
    securityNotePoints: {
      keepSecret: 'Gardez ce mot de passe confidentiel',
      changeAfterLogin: 'Changez-le après connexion',
      expires24Hours: 'Valable 24 heures'
    },
    resetNote: 'Note :',
    resetNotePoints: {
      registeredEmail: 'Utilisez votre e-mail professionnel',
      passwordDisplayed: 'Le mot de passe s\'affichera ici',
      changeRequired: 'Changement obligatoire à la première connexion'
    },
    copied: 'Copié',
    copySuccessMessage: 'Mot de passe copié !',
    forgotPassword: 'Mot de passe oublié ?',
    // Password Reset Email Request
    sendResetLink: 'Envoyer le lien',
    sendingEmail: 'Envoi...',
    emailSent: 'E-mail envoyé',
    emailSentMessage: 'Si l\'e-mail est enregistré, vous recevrez un lien de réinitialisation.',
    emailNotSent: 'E-mail non envoyé',
    emailSentInfo: 'Consultez vos e-mails (et spams)',
    checkEmail: 'Vérifier l\'e-mail',
    emailInstructions: 'Instructions envoyées par e-mail',
    nextSteps: 'Prochaines étapes :',
    nextStepsList: {
      checkInbox: 'Consultez vos e-mails et spams',
      clickLink: 'Cliquez sur le lien reçu',
      linkExpires: 'Valable 24h',
      contactSupport: 'Pas reçu ? Contactez le support',
      rateLimitInfo: 'Max. 3 demandes/heure'
    },
    // Password Reset Completion
    resetLinkSent: 'Lien de réinitialisation envoyé',
    resetSuccess: 'Mot de passe réinitialisé avec succès',
    passwordUpdated: 'Mot de passe mis à jour',
    passwordUpdateMessage: 'Mot de passe modifié. Vous pouvez vous connecter.',
    loginWithNewPassword: 'Se connecter',
    // Reset Token Page
    resetToken: 'Réinitialiser le mot de passe',
    invalidToken: 'Lien invalide',
    expiredToken: 'Lien expiré',
    tokenValid: 'Lien valide',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    updatePassword: 'Valider',
    updatingPassword: 'Mise à jour...',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    resetInstructions: 'Choisissez votre nouveau mot de passe',
  },
  accountInfo: {
    title: 'Informations du compte',
    loading: 'Chargement...',
    error: 'Erreur',
    errorMessage: 'Impossible de charger les informations',
    back: 'Retour',
    basicInfo: 'Informations de base',
    name: 'Nom',
    email: 'Adresse e-mail',
    contactId: 'ID Client Knitido',
    contactNumber: 'Numéro de contact',
    noInfo: 'Non renseigné',
    companyInfo: 'Entreprise',
    company: 'Entreprise',
    position: 'Poste',
    vatId: 'N° TVA',
    billingAddress: 'Adresse de facturation',
    deliveryAddress: 'Adresse de livraison',
    addressInfo: 'Adresses',
    billingDescription: 'Pour factures et contrats',
    deliveryDescription: 'Pour livraisons de produits',
    sameAsBilling: '※ Même adresse que facturation',
    sameAsDelivery: '※ Même adresse que livraison',
    companyName: 'Nom de l\'entreprise',
    contactPerson: 'Personne de contact',
    address: 'Adresse',
    phoneNumber: 'Numéro de téléphone',
    billingUsage: 'Pour factures et documents officiels',
    deliveryUsage: 'Pour livraison des commandes',
    alsoUsedForDelivery: 'Aussi pour les livraisons',
    accountType: 'Type de compte',
    addressId: 'ID d\'adresse',
    // Address editing functionality
    edit: 'Modifier',
    editDeliveryAddress: 'Modifier l\'adresse de livraison',
    editDeliveryDescription: 'Modifiez votre adresse de livraison',
    newDeliveryAddress: 'Ajouter une nouvelle adresse de livraison',
    newDeliveryDescription: 'Entrez les détails de votre nouvelle adresse de livraison',
    noDeliveryAddress: 'Aucune adresse de livraison configurée',
    success: 'Succès',
    addressUpdated: 'Adresse modifiée',
    updateError: 'Erreur de modification',
    requiredFields: 'Remplissez tous les champs requis',
    firstName: 'Prénom',
    lastName: 'Nom',
    streetAddress: 'Adresse',
    streetAddress2: 'Adresse 2',
    city: 'Ville',
    country: 'Pays',
    selectCountry: 'Sélectionner un pays...',
    searchCountry: 'Rechercher un pays...',
    noCountryFound: 'Aucun pays trouvé.',
    postalCode: 'Code postal',
    companyNamePlaceholder: 'Nom de l\'entreprise',
    firstNamePlaceholder: 'Prénom',
    lastNamePlaceholder: 'Nom',
    streetAddressPlaceholder: 'Numéro et rue',
    streetAddress2Placeholder: 'Complément (optionnel)',
    cityPlaceholder: 'Ville',
    postalCodePlaceholder: 'Code postal',
    billingNotEditable: 'Adresse de facturation non modifiable.',
    billingContactSupport: 'Contactez le support pour modifier.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} adresses de livraison',
    noDeliveryAddresses: 'Aucune adresse de livraison enregistrée',
    defaultAddress: 'Par défaut',
    selectDeliveryAddress: 'Sélectionner l\'adresse de livraison',
    addNewAddress: 'Ajouter une nouvelle adresse',
    editAddress: 'Modifier l\'adresse',
    deleteAddress: 'Supprimer l\'adresse',
    confirmDelete: 'Confirmer la suppression',
    confirmDeleteMessage: 'Voulez-vous vraiment supprimer cette adresse ? Cette action est irréversible.',
    addressAddedSuccess: 'Adresse de livraison ajoutée',
    addressDeletedSuccess: 'Adresse de livraison supprimée',
    deleteError: 'Échec de la suppression de l\'adresse',
    saving: 'Enregistrement...',
    cancel: 'Annuler',
    saveChanges: 'Enregistrer les modifications',
    selectedDeliveryAddress: 'Adresse de livraison sélectionnée',
  },
  dashboard: {
    title: 'Partenaire commercial',
    subtitle: 'Système de commande de produits',
    welcome: 'Bienvenue,',
    welcomeMessage: 'Bienvenue ! Commandez vos produits en toute simplicité.',
    productCatalog: 'Catalogue de produits',
    productCatalogDesc: 'Consultez et commandez nos produits',
    viewProducts: 'Voir les produits',
    orderHistory: 'Historique des commandes',
    orderHistoryDesc: 'Consultez vos commandes passées',
    accountSettings: 'Paramètres du compte',
    accountSettingsDesc: 'Gérez vos informations',
    comingSoon: 'Prochainement',
    infoTitle: 'Aide',
    orderingInfo: 'Commande de produits',
    orderingDesc: 'Choisissez produits, tailles et couleurs. Stock en temps réel.',
    supportInfo: 'Support',
    supportDesc: 'Questions ? Contactez-nous.',
    viewOrderHistory: 'Historique',
    viewOrders: 'Mes commandes',
    accountInfo: 'Informations du compte',
    accountInfoDesc: 'Consultez vos informations',
    viewDetails: 'Détails',
    supportEmail: 'b2b-partner@knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Lun-Ven 9h-15h CET',
    bulkImportDesc: 'Importer des commandes depuis Excel/CSV',
    importOrders: 'Importer des commandes',
  },
  products: {
    title: 'Liste des produits',
    subtitle: 'Partenaire commercial',
    searchPlaceholder: 'Nom de produit ou SKU...',
    productId: 'ID produit',
    addToCart: 'Ajouter au panier',
    selectVariation: 'Choisir variante',
    price: 'Prix',
    priceNetNotice: 'Prix hors taxes',
    stock: 'Stock',
    color: 'Couleur',
    newProducts: 'Nouveaux Produits',
    newProductBadge: 'NOUVEAU',
    size: 'Taille',
    quantity: 'Quantité',
    total: 'Total',
    cart: 'Panier',
    checkout: 'Passer commande',
    csvMode: 'Mode rapide CSV',
    csvInfo: 'Données issues du fichier CSV',
    csvUploadDate: 'Importé le :',
    stockNote: '※ Stock actualisé à la sélection de variante',
    noProducts: 'Aucun produit trouvé',
    noProductsDesc: 'Modifiez votre recherche ou importez un fichier CSV.',
    retry: 'Réessayer',
    pagination: 'articles',
    variations: 'variantes',
    stockFetchError: 'Erreur stock',
    stockFetchFailed: 'Stock indisponible',
    stockFetchFailedDesc: 'Stock indisponible. Affichage des données CSV.',
    stockFetched: 'Stock actualisé',
    totalStock: 'Stock total',
    noStockAll: 'Aucun stock disponible',
    noStockData: 'Données stock absentes',
    stockFetchErrorDesc: 'Erreur lors de la récupération du stock',
    selectionError: 'Sélection incorrecte',
    enterQuantity: 'Quantité requise',
    addedToCart: 'Ajouté !',
    typesAdded: ' produits ajoutés',
    addToCartError: 'Erreur d\'ajout au panier',
    addToCartErrorDesc: 'Veuillez réessayer',
    loadingStock: 'Vérification du stock...',
    csvDataInfo: 'Données CSV (stock non actualisé)',
    filterByCategory: 'Filtrer par catégorie',
    allProducts: 'Tous les produits',
    applyFilters: 'Appliquer les filtres',
    clearFilters: 'Effacer les filtres',
    filters: 'Filtres',
    clearAll: 'Tout effacer',
    invalidDataFormat: 'Format de données invalide',
    loadFailed: 'Chargement échoué',
    csvUploadComplete: 'Import terminé',
    csvLoadedDesc: ' produits importés. Stock actualisé à la sélection.',
    searchTitle: 'Recherche de produits',
    loadingProducts: 'Chargement produits...',
    noProductsCsv: 'Aucun produit dans le CSV. Modifiez votre recherche.',
    paginationDisplay: ' affichés',
    previous: 'Précédent',
    next: 'Suivant',
    selectionSummary: 'Récapitulatif',
    selectedQuantity: 'Quantité sélectionnée',
    items: ' articles',
    viewDetails: 'Détails',
    productImage: 'Image du produit',
    correspondingVariations: 'Variantes disponibles',
    clickToEnlarge: 'Agrandir',
    productIdLabel: 'ID produit',
    colorLabel: 'Couleur',
  },
  productDetail: {
    title: 'Détails du produit',
    backToProducts: 'Retour aux produits',
    productNotFound: 'Produit non trouvé',
    productNotFoundDesc: 'Produit introuvable ou supprimé.',
    loading: 'Chargement...',
    imageLoadError: 'Images non disponibles',
    noImages: 'Aucune image disponible',
    productDescription: 'Description du produit',
    colors: 'Couleurs',
    sizes: 'Tailles',
    colorCount: 'couleurs',
    sizeCount: 'tailles',
    variationCount: 'variantes',
    selectVariation: 'Choisir variantes',
    descriptionLanguageNote: '※ Descriptions en anglais/allemand uniquement',
  },
  colors: {
    schwarz: 'Noir',
    weiß: 'Blanc',
    grau: 'Gris',
    rot: 'Rouge',
    blau: 'Bleu',
    grün: 'Vert',
    gelb: 'Jaune',
    rosa: 'Rose',
    lila: 'Violet',
    braun: 'Marron',
    orange: 'Orange',
    beige: 'Beige',
    navy: 'Marine',
    dunkelblau: 'Bleu foncé',
    hellblau: 'Bleu clair',
    dunkelgrau: 'Gris foncé',
    hellgrau: 'Gris clair',
    bordeaux: 'Bordeaux',
    türkis: 'Turquoise',
    khaki: 'Kaki',
    mint: 'Menthe',
    violett: 'Violet',
    anthrazit: 'Anthracite',
    blaugrau: 'Gris-bleu',
    burgunderrot: 'Bourgogne',
    elfenbein: 'Ivoire',
    karminrot: 'Carmin',
    neongrün: 'Vert néon',
    gelbgrün: 'Vert jaune',
    pistazie: 'Pistache',
    // Noms de couleurs en anglais (utilisés dans Product ID 237, etc.)
    blue: 'Bleu',
    ivory: 'Ivoire',
    green: 'Vert',
    gold: 'Or',
    red: 'Rouge',
  },
  categories: {
    category_21: 'Accessoires',
    category_23: 'Chaussettes basiques',
    category_24: 'Offres',
    category_29: 'B2B'
  },
  checkout: {
    title: 'Paiement',
    cartReview: 'Vérification',
    orderSummary: 'Récapitulatif',
    shippingInfo: 'Informations de livraison',
    billingInfo: 'Informations de facturation',
    orderNotes: 'Notes de commande',
    orderNotesPlaceholder: 'Notes ou demandes spéciales...',
    contactPerson: 'Personne de contact',
    phoneNumber: 'Numéro de téléphone',
    email: 'Adresse e-mail',
    company: 'Entreprise',
    address: 'Adresse',
    city: 'Ville',
    postalCode: 'Code postal',
    country: 'Pays',
    deliveryDate: 'Date de livraison',
    urgentDelivery: 'Livraison express (3-5 jours ouvrables)',
    standardDelivery: 'Livraison standard (7-10 jours ouvrables)',
    placeOrder: 'Passer la commande',
    backToCart: 'Retour au panier',
    requiredField: 'Champ obligatoire',
    orderTotal: 'Total de la commande',
    subtotal: 'Sous-total',
    priceNetNotice: 'Prix hors taxes',
    stockReservationNotice: 'Stock réservé après confirmation.',
    stockCheckError: 'Erreur stock',
    stockCheckErrorDesc: 'Vérification impossible. Réessayez.',
    shipping: 'Livraison',
    shippingCost: 'Livraison',
    tax: 'Taxe',
    orderSuccess: 'Commande réussie',
    orderSuccessMessage: 'Votre commande a été soumise avec succès. Numéro de commande: {orderNumber}',
    orderNumber: 'Numéro de commande',
    thankYou: 'Merci pour votre commande !',
    orderConfirmation: 'Commande envoyée !',
    orderProcessing: 'Confirmation par e-mail après validation.',
    orderProcessingMessage: 'Commande envoyée. Confirmation par e-mail après validation.',
    continueShopping: 'Continuer les achats',
    emptyCart: 'Votre panier est vide',
    emptyCartMessage: 'Veuillez ajouter des produits à votre panier pour continuer',
    stockWarning: 'Avertissement de stock',
    stockWarningDesc: 'Stock insuffisant. Ajustez les quantités.',
    stockError: 'Erreur de stock',
    stockErrorDesc: 'Stock insuffisant. Modifiez les quantités.',
    refreshStock: 'Actualiser le stock',
    stockUpdated: 'Stock mis à jour',
    stockUpdatedDesc: 'Stock actualisé - {changed} changements',
    stockCheckDesc: 'Vérification stock effectuée',
    stockOk: 'Stock OK',
    stockShortage: 'Rupture de stock',
    requestedQty: 'Qté demandée',
    currentStock: 'Stock actuel',
    stockShortageMsg: 'Stock insuffisant. Modifiez la quantité.',
    stockIssueWarning: 'Commande impossible - stock insuffisant.',
    stockDataMissing: 'Vérification du stock en cours...',
    outOfStock: 'Rupture de stock.',
    maxAvailable: 'Maximum',
    autoRestored: 'Panier restauré',
    autoRestoredDesc: 'Les articles de votre dernière session ont été restaurés',
    maxQuantityReached: 'Quantité max atteinte.',
    // ERP Contact Search
    contactSearch: 'Recherche de contact client',
    contactSearchDesc: 'Saisissez l\'e-mail du client',
    emailAddress: 'Adresse e-mail',
    searchButton: 'Rechercher',
    searching: 'Recherche...',
    contactFound: 'Contact trouvé',
    contactNotFound: 'Contact non trouvé',
    contactId: 'ID Client Knitido',
    companyName: 'Entreprise',
    contactPersonLabel: 'Personne de contact',
    addressesFound: 'Adresses trouvées',
    addressType: 'Type',
    addressBilling: 'Adresse de facturation',
    addressDelivery: 'Adresse de livraison',
    vatSourceCompany: 'Info entreprise',
    vatSourceBilling: 'Facturation',
    vatSourceDelivery: 'Livraison',
    addressOther: 'Autre',
    addressDetails: 'Adresse',
    loadingAddresses: 'Chargement des informations d\'adresse...',
    addressRetrieved: 'Informations d\'adresse récupérées',
    addressNotFound: 'Informations d\'adresse non trouvées',
    addressNotFoundDesc: 'Adresse non trouvée. Saisie manuelle requise.',
    addressError: 'Erreur adresse',
    addressErrorDesc: 'Impossible de charger l\'adresse.',
    contactNotConfirmed: 'Contact client non confirmé',
    contactNotConfirmedDesc: 'Recherchez d\'abord le contact client.',
    searchContact: 'Rechercher un contact',
    inputError: 'Erreur de saisie',
    inputErrorDesc: 'Informations incomplètes.',
    processing: 'Traitement en cours...',
    erpContactSearch: 'Recherche de contact client',
    contactSearchError: 'E-mail non reconnu.',
    // Product Images Toggle
    showProductImages: 'Afficher les images de produits',
    showProductImagesDesc: 'Affiche les photos produits (chargement plus lent)',
    // System Registration Info
    systemRegistrationInfo: 'Vos informations client',
    editShippingAddress: 'Modifier l\'adresse de livraison',
    systemRegistrationInfoDesc: 'Vos données entreprise. Pour modifier la facturation, contactez votre commercial.',
    // Order Summary
    regularPrice: 'Prix de gros régulier',
    offeredPrice: 'Prix proposé',
    discount: 'Remise',
    b2bCustomer: 'Client B2B',
    pattern: 'Modèle',
    specialPriceApplied: 'Prix spécial appliqué',
    customerClassification: 'Classification client',
    paymentCondition: 'Conditions de paiement',
    invoice: 'Facture (NET 30)',
    prepayment: 'Prépaiement',
    paymentMethod: 'Mode de paiement',
    invoicePayment: 'Paiement par facture',
    estimatedSubtotal: 'Sous-total estimé',
    estimatedTotal: 'Total estimé',
    orderSummaryDisclaimer: 'Prix estimatifs. Confirmation définitive avec prix, livraison et taxes par e-mail.',
    searchError: 'Erreur de recherche',
    searchErrorDesc: 'Erreur de recherche.',
    confirmDeleteItem: 'Supprimer l\'article',
    itemDeleted: 'Article supprimé',
    confirmDeleteItemDesc: 'Supprimer cet article du panier ?',
    deleteConfirm: 'Supprimer',
    contactNotes: 'Notes de contact',
    contactNotesDesc: 'Questions ou demandes spéciales ? (optionnel)',
    contactNotesLabel: 'Message',
    contactNotesPlaceholder: 'Ex : questions produits, demandes spéciales...',
    characters: 'caractères',
    contactIdLabel: 'ID Client Knitido',
    companyLabel: 'Entreprise',
    personLabel: 'Personne de contact',
    emailLabel: 'E-mail',
    addressTypeLabel: 'Type',
    destinationLabel: 'Destination',
    // Shipping Form
    shippingTitle: 'Informations de livraison',
    shippingDesc: 'Où livrer vos produits ?',
    companyRequired: 'Entreprise *',
    contactPersonRequired: 'Personne de contact *',
    emailRequired: 'Adresse e-mail *',
    phoneRequired: 'Numéro de téléphone *',
    addressRequired: 'Adresse 1 *',
    address2: 'Complément (Bât./App.)',
    postalCodeRequired: 'Code postal *',
    cityRequired: 'Ville *',
    countryRequired: 'Pays *',
    selectCountry: 'Choisir pays',
    shippingMethodRequired: 'Livraison *',
    selectShippingMethod: 'Choisir livraison',
    urgentDeliveryOption: 'Express (supplément)',
    deliveryNotes: 'Notes de livraison',
    deliveryNotesPlaceholder: 'Préférences de livraison...',
    standardShipping: 'Livraison standard (3-5 jours ouvrables)',
    expressShipping: 'Livraison express (1-2 jours ouvrables)',
    overnightShipping: 'Livraison de nuit',
    germany: 'Allemagne',
    austria: 'Autriche',
    switzerland: 'Suisse',
    japan: 'Japon',
    shippingAddressLabel: 'Adresse de livraison',
    changeDeliveryAddress: 'Modifier l\'adresse de livraison',
    selectDeliveryAddress: 'Sélectionner l\'adresse de livraison',
    // Shipping Cost Details
    freeShipping: 'Livraison gratuite',
    shippingError: 'Erreur',
    shippingZone: 'Zone de livraison',
    remainingForFreeShipping: '{amount} de plus pour la livraison gratuite',
    moreForFreeShipping: 'pour la livraison gratuite',
    freeShippingProgress: 'Livraison gratuite à',
    andAboveFreeShipping: 'et plus pour la livraison gratuite',
    freeShippingAchieved: 'Livraison gratuite appliquée',
    threshold: 'et plus',
    nextShippingTier: 'Prochaine remise de livraison',
    moreForDiscount: 'de plus pour',
    shippingSavings: 'économies de livraison',
    orderAmountThreshold: 'et plus pour',
    specialRegionNotice: 'Région de livraison spéciale appliquée',
    defaultShippingApplied: 'Tarifs de livraison standard appliqués',
    requestedQuantity: 'Quantité demandée',
    availableQuantity: 'Quantité disponible',
    orderSubmitError: 'Erreur de commande',
    orderSubmitErrorDesc: 'Impossible de soumettre la commande',
    upload: {
      title: 'Importer une commande Excel/CSV',
      description: 'Télécharger un fichier Excel ou CSV avec vos données de commande',
      dragDropOrClick: 'Glisser & déposer le fichier ici ou cliquer pour sélectionner',
      dropHere: 'Déposer le fichier ici',
      supportedFormats: 'Formats acceptés : Excel (.xlsx, .xls) et CSV (.csv)',
      maxSize: 'Taille maximale : {size} MB',
      processFile: 'Traiter le fichier',
      processing: 'Traitement en cours...',
      ready: 'Fichier prêt pour la prévisualisation',
      readyDescription: 'Votre fichier a été traité avec succès et est prêt à être examiné.',
      preview: 'Afficher l\'aperçu',
      errors: {
        fileTooLarge: 'Fichier trop volumineux. Taille maximale : {size} MB',
        invalidFileType: 'Type de fichier invalide. Veuillez télécharger un fichier Excel ou CSV',
        uploadFailed: 'Erreur lors du téléchargement du fichier',
      },
    },
    // Loading messages
    loadingPage: 'Chargement...',
    loadingStock: 'Vérification stock...',
    loadingAccount: 'Chargement compte...',
    loadingError: 'Erreur de chargement',
    loadingData: 'Chargement des données',
    // Toast messages
    addressRetrievedTitle: 'Adresse trouvée',
    addressSetAsDelivery: ' sera l\'adresse de livraison.',
    contactFoundDesc: ' identifié.'
  },
  orderHistory: {
    title: 'Historique des commandes',
    searchPlaceholder: 'N° commande ou SKU...',
    noOrders: 'Aucune commande trouvée',
    noOrdersFound: 'Aucun résultat',
    startShopping: 'Voir les produits',
    orderItems: 'Articles de la commande',
    viewDetails: 'Détails',
    reorder: 'Commander à nouveau',
    orderDate: 'Date de commande',
    orderStatus: 'Statut',
    orderTotal: 'Total de la commande',
    // Status translations
    statusPending: 'Paiement en attente',
    statusProcessing: 'En traitement',
    statusConfirmed: 'Confirmé',
    statusShipped: 'Expédié',
    statusDelivered: 'Livré',
    statusCancelled: 'Annulé',
    statusReturned: 'Retourné',
    statusRefunded: 'Remboursé',
    statusWarranty: 'Sous garantie',
    statusExchanged: 'Échangé',
    statusRepair: 'En réparation',
    statusUnknown: 'Inconnu',
    statusIncomplete: 'Incomplet',
    statusWaitingPayment: 'En attente de paiement',
    statusInPreparation: 'En préparation',
    statusClearedShipping: 'Prêt pour expédition',
    statusBeingShipped: 'En cours d\'expédition',
    statusOutgoingBooked: 'Expédition réservée',
    statusReturn: 'Retour',
    // Additional UI elements
    itemCount: 'articles',
    itemCountSingular: 'article',
    refreshButton: 'Actualiser',
    errorFetchingOrders: 'Erreur chargement historique',
    // Payment status features
    paymentStatus: 'Statut de paiement',
    markAsPaid: 'Marquer comme payé',
    unmarkAsPaid: 'Annuler le marquage payé',
    paidOn: 'Payé le',
    paymentMarked: 'Payé',
    notPaid: 'Non payé',
    paymentMarkedSuccess: 'Marqué comme payé',
    paymentUnmarkedSuccess: 'Marquage payé annulé',
    paymentUpdateError: 'Erreur lors de la mise à jour du statut de paiement',
    // Payment date dialog
    paymentDateTitle: 'Saisir les informations de paiement',
    paymentDateDescription: 'Saisir les informations de paiement pour la commande {orderNumber}',
    paymentDateLabel: 'Date de paiement',
    selectDate: 'Sélectionner une date',
    paymentDateHelp: 'Sélectionnez la date du virement bancaire',
    paymentMethodLabel: 'Méthode de paiement',
    bankTransfer: 'Virement bancaire',
    invoice: 'Facture',
    otherPayment: 'Autre',
    paymentReferenceLabel: 'Référence de paiement',
    paymentReferencePlaceholder: 'ex. Virement du 01/01/2024',
    paymentReferenceHelp: 'Saisissez des informations pour faciliter le rapprochement',
    notesLabel: 'Notes',
    notesPlaceholder: 'Informations supplémentaires sur le paiement',
    // Filter options
    filterByPaymentStatus: 'Filtrer par statut de paiement',
    allOrders: 'Toutes les commandes',
    paidOrders: 'Payées',
    unpaidOrders: 'Non payées',
    // Sorting options
    sortBy: 'Trier par',
    sortByDate: 'Date de commande',
    sortByPaymentDate: 'Date de paiement',
    sortByAmount: 'Montant',
    sortByStatus: 'Statut',
  },
  orderDetails: {
    title: 'Détails de la commande',
    notFound: 'Commande introuvable',
    backToHistory: 'Retour à l\'historique',
    orderDate: 'Date de commande',
    orderItems: 'Articles de la commande',
    deliveryStatus: 'Statut de livraison',
    estimatedDelivery: 'Livraison estimée',
    deliveredOn: 'Livré le',
    downloadInvoice: 'Télécharger la facture',
    statusDelivered: 'Livré',
    statusShipped: 'Expédié',
    statusConfirmed: 'Confirmé',
    statusCancelled: 'Annulé',
    errorFetchingDetails: 'Erreur chargement détails',
  },
  company: {
    name: 'Partenaire commercial',
    tagline: 'Plateforme professionnelle',
    copyright: '© 2025 Knitido. Tous droits réservés.',
  },
  footer: {
    phone: 'Téléphone',
    email: 'E-mail',
    countries: {
      DE: 'Allemagne',
      AT: 'Autriche',
      CH: 'Suisse',
      FR: 'France',
      IT: 'Italie',
      ES: 'Espagne',
      NL: 'Pays-Bas',
      BE: 'Belgique',
      PL: 'Pologne',
      SE: 'Suède',
      NO: 'Norvège',
      FI: 'Finlande',
      DK: 'Danemark',
      LT: 'Lituanie',
      LV: 'Lettonie',
      EE: 'Estonie',
    },
  },
  cart: {
    newCart: 'Nouveau panier',
    currentCart: 'Panier actuel',
    modified: 'modifié',
    lastSaved: 'Dernière sauvegarde',
    unsavedChanges: 'non enregistré',
    saveCart: 'Enregistrer le panier',
    loadCart: 'Charger le panier',
    deleteCart: 'Supprimer le panier',
    startNewCart: 'Commencer un nouveau panier',
    savedCarts: 'Paniers enregistrés',
    cartSaved: 'Panier enregistré',
    cartDeleted: 'Panier supprimé',
    confirmDeleteCart: 'Supprimer ce panier ?\n\nAction irréversible.',
    confirmSwitchCart: 'Panier non sauvegardé.\n\nLes modifications seront perdues.\n\nContinuer ?',
    confirmSwitchCartTitle: 'Changer de panier',
    confirmNewCart: 'Panier non sauvegardé.\n\nLes modifications seront perdues.\n\nContinuer ?',
    confirmNewCartTitle: 'Démarrer un nouveau panier',
    confirmClearCart: 'Vider le panier ?\n\n{count} articles supprimés.\n\nAction irréversible.',
    confirmClearCartTitle: 'Vider le panier',
    autoSaved: 'Sauvegarde automatique',
    itemsWillBeRemoved: 'articles supprimés',
    changesWillBeLost: 'modifications perdues',
    continueQuestion: 'Continuer ?',
    cartStatus: 'Statut du panier',
    cartName: 'Nom du panier',
    cartNamePlaceholder: 'Ex : Commande mars 2025',
    cartNameRequired: 'Nom requis',
    saveCartDescription: 'Nommez et sauvegardez ce panier pour plus tard.',
    cancelCart: 'Annuler le panier',
    proceedToCheckout: 'Passer à la caisse',
    emptyCart: 'Le panier est vide',
    erpDown: 'Le système de commandes est en panne. Veuillez réessayer plus tard.',
    erpDegraded: 'Le système est actuellement instable. Les commandes peuvent échouer.',
    erpDownSaveHint: 'Enregistrez votre panier et passez votre commande une fois le système rétabli.',
    erpSaveCart: 'Sauvegarder le panier',
  },
  nav: {
    dashboard: 'Accueil',
    products: 'Produits',
    orderHistory: 'Mes commandes',
    account: 'Mon compte',
    bulkImport: 'Import en masse',
  },
  settings: {
    selectLanguage: 'Choisir la langue',
    languagePreferenceSaved: 'Langue sauvegardée pour vos prochaines visites.',
  },
  reorder: {
    allItemsAdded: '{count} articles ajoutés au panier',
    partialSuccess: '{added} articles ajoutés. {failed} articles n\'ont pas pu être ajoutés',
    allItemsFailed: 'Impossible d\'ajouter les articles au panier',
    error: 'Une erreur s\'est produite lors de la nouvelle commande',
    itemDiscontinued: '{name} ({color}/{size}) a été discontinué',
    itemOutOfStock: '{name} ({color}/{size}) est en rupture de stock',
    partialStock: '{name} ({color}/{size}) seulement {available} disponible(s)',
    confirmReorder: 'Confirmer la nouvelle commande',
    confirmReorderMessage: 'Ajouter les articles de cette commande à votre panier?',
    addingToCart: 'Ajout au panier...',
    checkingStock: 'Vérification du stock...',
    checkoutTitle: 'Articles ajoutés au panier',
    checkoutDescription: '{count} articles ajoutés au panier. Voulez-vous passer à la caisse ?',
  },
  bulkImport: {
    instructions: 'Comment importer des commandes',
    step1: 'Téléchargez le fichier modèle de commande',
    step2: 'Remplissez vos données de commande avec SKU et quantité',
    step3: 'Enregistrez en fichier Excel (.xlsx) ou CSV',
    step4: 'Téléchargez le fichier en utilisant le formulaire ci-dessous',
    step5: 'Vérifiez et confirmez votre commande',
    downloadTemplate: 'Télécharger le modèle',
    formatGuide: 'Guide de format de fichier',
    requiredColumns: 'Colonnes obligatoires',
    skuDescription: 'Code SKU du produit',
    quantityDescription: 'Quantité à commander (nombre entier positif)',
    optionalColumns: 'Colonnes optionnelles',
    notesDescription: 'Notes internes (ex: n° PO, références) - pour vos propres dossiers uniquement',
    formatNote: 'La première ligne doit contenir les en-têtes de colonnes. Les données commencent à partir de la deuxième ligne.',
    parseSuccess: '{count} articles analysés avec succès depuis le fichier',
    parseError: 'Erreur d\'analyse',
    validationError: 'Erreurs de validation',
    validationErrorGuidance: 'Veuillez cliquer sur le bouton « {showPreviewButton} » pour consulter les détails.',
    warnings: 'Avertissements',
    itemsParsed: '{count} articles analysés avec succès :',
    andMore: '...et {count} autres articles',
    validationSummary: 'Résumé de validation',
    duplicateSKUs: 'SKU en double détectés',
    skuFormat: 'Le SKU doit contenir uniquement des lettres, chiffres et tirets',
    quantityRange: 'La quantité doit être entre 1 et 9999',
    maxRows: 'Maximum 1000 lignes autorisées',
    rowsSkipped: '{count} lignes ont été ignorées en raison d\'erreurs',
    previewTitle: 'Aperçu de la commande',
    previewDescription: 'Vérifiez et modifiez vos données de commande avant de continuer',
    proceedToCart: 'Ajouter au panier',
    // File parsing messages
    fileEmpty: 'Le fichier est vide ou ne contient aucune donnée',
    fileTooManyRows: 'Le fichier contient trop de lignes ({current}). Maximum autorisé : {max}',
    invalidRowFormat: 'Format de ligne invalide',
    missingColumns: 'Colonnes obligatoires manquantes (SKU et Quantité)',
    missingSku: 'SKU manquant',
    invalidSkuFormat: 'Format SKU invalide : "{sku}" (doit correspondre au modèle : {pattern})',
    skuTooLong: 'SKU trop long : "{sku}" (maximum 50 caractères)',
    invalidQuantity: 'Quantité invalide : "{quantity}" n\'est pas un nombre',
    quantityTooLow: 'Quantité trop faible : {quantity} (minimum : {min})',
    quantityTooHigh: 'Quantité trop élevée : {quantity} (maximum : {max})',
    notesRequired: 'Le champ notes est obligatoire',
    noValidData: 'Aucune donnée valide trouvée. Veuillez vérifier le format de votre fichier.',
    row: 'Ligne {row} : {errors}',
    rowErrors: '...et {count} autres erreurs',
    duplicateSkuInRows: 'SKU en double "{sku}" trouvé aux lignes : {rows}',
    quantityExceedsMax: 'Ligne {row} : La quantité {quantity} dépasse le maximum autorisé ({max})',
    quantityBelowMin: 'Ligne {row} : La quantité {quantity} est inférieure au minimum requis ({min})',
    // Validation messages
    unsupportedFileFormat: 'Format de fichier non pris en charge. Veuillez télécharger un fichier CSV ou Excel.',
    csvParsingErrors: 'Des erreurs d\'analyse CSV se sont produites',
    failedToParseFile: 'Échec de l\'analyse du fichier',
    failedToParseExcel: 'Échec de l\'analyse du fichier Excel',
    failedToReadFile: 'Échec de la lecture du fichier',
    unknownError: 'Une erreur inconnue s\'est produite',
    totalRows: 'Total des lignes',
    valid: 'Valide',
    invalid: 'Invalide',
    skipped: 'Ignoré',
    // SKU validation
    skuValidationError: 'Erreur de validation SKU',
    skuValidationFailed: 'Échec de la validation des SKU. Vous pouvez continuer mais certains articles peuvent ne pas être disponibles.',
    skuNotFound: 'SKU introuvable dans la base de données',
    skusNotFound: '{count} SKU introuvables dans la base de données',
    itemsHaveInsufficientStock: '{count} articles ont un stock insuffisant',
    validatingSKUs: 'Vérification des articles...',
    unvalidatedChanges: 'Vous avez des modifications non validées. Veuillez revalider avant d\'ajouter au panier.',
    revalidate: 'Revalider',
    validating: 'Validation...',
    validationSuccess: 'Tous les articles sont valides',
    validationComplete: 'Validation terminée',
    validationResultSummary: '{errors} erreurs, {warnings} avertissements trouvés',
    // Table headers
    actions: 'Actions',
    notes: 'Notes',
    // Status filter
    all: 'Tous',
    hasErrors: 'Avec erreurs',
    // Selection summary
    selected: 'sélectionné(s)',
    errors: 'erreur(s)',
    // Pagination
    page: 'Page {current} sur {total}',
    previous: 'Précédent',
    next: 'Suivant',
    noResults: 'Aucun résultat.',
    // Cart integration
    noValidItems: 'Aucun article valide',
    allItemsHaveErrors: 'Tous les articles ont des erreurs de validation. Veuillez les corriger avant de continuer.',
    dataLoadingError: 'Erreur de chargement des données',
    failedToLoadProductData: 'Échec du chargement des données produit. Veuillez réessayer.',
    itemsAddedToCart: '{count} articles ajoutés au panier',
    itemsAddedMessage: '{count} articles ajoutés au panier',
    someSkusNotFound: '{count} SKU n\'ont pas pu être trouvés.',
    noItemsAdded: 'Aucun article ajouté',
    couldNotFindProducts: 'Impossible de trouver des produits correspondant aux SKU.',
    errorAddingToCart: 'Erreur',
    failedToAddToCart: 'Échec de l\'ajout des articles au panier. Veuillez réessayer.',
    addingToCart: 'Ajout au panier...',
    // File info
    fileSelected: '{name} sélectionné pour traitement',
    fileSize: '{size} octets',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Téléchargement du modèle',
    templateWillBeImplemented: 'Le téléchargement du modèle sera implémenté dans la phase 7',
    // Additional validation
    validationFailed: 'Échec de la validation',
    // Template download
    templateDownloaded: 'Modèle téléchargé avec succès',
    templateDownloadError: 'Échec du téléchargement du modèle',
    downloadExcelTemplate: 'Télécharger le modèle Excel',
    downloadCsvTemplate: 'Télécharger le modèle CSV',
    // Template content
    sheetName: 'Commande en masse',
    instructionsSheetName: 'Instructions',
    columnDescriptions: 'Descriptions des colonnes :',
    columnHeader: 'Colonne',
    columnRequired: 'Obligatoire',
    columnOptional: 'Optionnel',
    columnDescription: 'Description',
    templateNotes: 'Notes :',
    templateNote1: 'La première ligne doit contenir les en-têtes de colonnes exactement comme indiqué',
    templateNote2: 'Les données commencent à partir de la ligne 2',
    templateNote3: 'Le SKU doit correspondre aux codes produits existants dans le système',
    templateNote4: 'La quantité doit être un entier positif entre 1 et 9999',
    templateNote5: 'Maximum 1000 lignes autorisées par fichier',
    templateNote6: 'Enregistrer au format .xlsx ou .csv',
    stockAvailabilityWarning: 'La disponibilité réelle des stocks sera vérifiée sur la page de paiement suivante.',
    outOfStock: 'Rupture de stock',
    insufficientStock: 'Stock insuffisant: {available} disponible, {requested} demandé',
  },
  orderExport: {
    export: 'Exporter la commande',
    exportOrder: 'Exporter les données de commande',
    exportAsCSV: 'Exporter en CSV',
    exportAsExcel: 'Exporter en Excel',
    exportForReorder: 'Exporter pour import en masse',
    detailed: 'Détails complets',
    simpleFormat: 'Format d\'import',
  },
};